import { render, staticRenderFns } from "./assetsUpdate.vue?vue&type=template&id=5e7679cc&scoped=true&"
import script from "./assetsUpdate.vue?vue&type=script&lang=js&"
export * from "./assetsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./assetsUpdate.vue?vue&type=style&index=0&id=5e7679cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7679cc",
  null
  
)

export default component.exports